import $ from 'jquery'

import {addAnimation} from "./observers/animations";

let animating = false;
const nav = 'nav.header-navigation';


function initNavigation() {
    if ($(nav).length !== 0) {
        //console.log('navigation present');
        $(window).on('load', function () {
            setListeners()

            $('.current-page-ancestor, .current-menu-item').addClass('device-open-subnav');
        // .current-menu-ancestor,
        // .current-menu-parent,
        // .current-page-parent {




        });
    }
}

function setListeners() {
    $('.inline-mobile').on('click', function (event) {
        $('.header-navigation').toggleClass('nav-open');
        $('body').toggleClass('nav-open');
    });
    $('.page-header .menu-item:not(.menu-item-object-custom) a').on('click', function (event) {
        $('.header-navigation').removeClass('nav-open');
        $('body').removeClass('nav-open');
    });



    $('.device-mobile .menu-item.menu-item-has-children.menu-item-object-custom, .device-tablet.portrait .menu-item.menu-item-has-children.menu-item-object-custom').on('click', function (event) {
        //
        // event.preventDefault();

        // if( $(event.target).closest('a').length==0 ){

            $(this).toggleClass('device-open-subnav');
            // //console.log('Psudo :before element is clicked!');
        // }
    });



    // const $body = $('body')

	// $(document).on('pub:unscrolled', function () {
	// 	$body.addClass('unscrolled').removeClass('scrolled')
	// })
	// $(document).on('pub:scrolled', function () {
	// 	$body.addClass('scrolled').removeClass('unscrolled')
	// })

}

export default initNavigation;


